var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Confirmation',{ref:"Confirmation"}),_c('Upload',{ref:"Upload"}),_c('Password',{ref:"Password"}),_c('ControlIdInit',{ref:"ControlIdInit"}),_c('DeviceTokenDialog',{ref:"DeviceTokenDialog"}),_c('MonthDialog',{ref:"MonthDialog"}),_c('DayDialog',{ref:"DayDialog"}),_c('GenerateAccessChargeDialog',{ref:"GenerateAccessChargeDialog"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }